module.exports = __webpack_public_path__ + "img/plan.1352e564.png";